import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { COMPANY } from "../mock";

const HIGHLIGHTS = [
  "Hunter Douglas Authorised Channel Partner",
  "End-to-end design, supply & installation",
  "Pan-India project execution capability",
  "In-house engineering & shop drawings",
  "Strict QA/QC and HSE compliance",
  "Material & workmanship warranty"
];

export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        {/* Left visual */}
        <div className="relative">
          <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxzdGFuZGluZyUyMHNlYW0lMjByb29maW5nfGVufDB8fHx8MTc3OTc5NTQ3MXww&ixlib=rb-4.1.0&q=85"
              alt="Newcon Roofing & Ceiling project"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 md:-right-8 bg-[#C9A227] text-white p-7 rounded-xl shadow-2xl max-w-[240px]">
            <div className="display text-6xl font-extrabold leading-none">{COMPANY.experienceYears}+</div>
            <div className="mt-2 text-sm font-semibold uppercase tracking-wider">Years of Roofing & Ceiling Excellence</div>
          </div>
          <div className="absolute -top-6 -left-4 md:-left-8 w-24 h-24 diag-stripes rounded-lg hidden md:block" />
        </div>

        {/* Right copy */}
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-700">About Newcon Roofing & Ceiling</div>
          <h2 className="display section-underline mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 uppercase">
            Roofing & Ceiling.<br />Engineered To Perform.
          </h2>
          <p className="mt-7 text-slate-600 leading-relaxed text-lg">
            Newcon Roofing & Ceiling (NRC) is a specialist contractor for metal roofing, false ceilings, under-deck insulation, suspended grid ceilings, acoustic ceilings and roof & wall cladding. Backed by deep manufacturer partnerships — including <span className="font-semibold text-slate-900">Hunter Douglas</span> — we deliver projects that stand the test of time.
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed">
            From warehouses to malls, factories to corporate HQs — our engineers and installers handle every scope with measured precision, certified materials and uncompromising QA/QC.
          </p>

          <ul className="mt-7 grid sm:grid-cols-2 gap-3">
            {HIGHLIGHTS.map((h) => (
              <li key={h} className="flex items-start gap-2 text-slate-700">
                <span className="shrink-0 mt-1 w-5 h-5 rounded-full bg-yellow-100 grid place-items-center">
                  <Check className="w-3 h-3 text-yellow-800" />
                </span>
                <span className="text-sm font-medium">{h}</span>
              </li>
            ))}
          </ul>

          <div className="mt-9 flex flex-wrap gap-4">
            <a href="#services">
              <Button size="lg" className="bg-slate-900 hover:bg-slate-800 text-white font-semibold px-7 h-12">
                Our Capabilities <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </a>
            <a href="#projects">
              <Button size="lg" variant="outline" className="border-slate-300 text-slate-900 hover:bg-slate-50 font-semibold px-7 h-12">
                View Projects
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
